export default function groupVeilleByMonth(root = document.querySelector('[data-veille-feed]')) {
  if (!root) {
    return;
  }

  const articles = [...root.querySelectorAll('article[data-month]')].filter((article) => !article.hidden);

  root.replaceChildren();

  let currentMonth = '';
  let group = null;

  articles.forEach((article) => {
    const month = article.getAttribute('data-month');
    const label = article.getAttribute('data-month-label');
    if (!month) {
      root.append(article);
      return;
    }
    if (month !== currentMonth) {
      currentMonth = month;
      group = document.createElement('section');
      group.className = 'gh-veille-group';
      const heading = document.createElement('h2');
      heading.className = 'gh-veille-month';
      heading.textContent = label
        ? label.charAt(0).toLocaleUpperCase('fr-FR') + label.slice(1)
        : '';
      group.append(heading);
      root.append(group);
    }
    group.append(article);
  });
}
